var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1ToA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 806,
    height: 806,
    viewBox: "0 0 806 806",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.254 356.671L112.225 210.379",
    stroke: "currentColor",
    strokeWidth: 74.56,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.31 167.769C167.928 108.757 177.891 365.746 177.891 365.746",
    stroke: "currentColor",
    strokeWidth: 74.5563,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.229 50.9072V286H697.822V104.403L642.07 122.128V85.5508L739.233 50.9072H744.229Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.338 555.513L106.529 750H55.1279L142.301 515.391H175.011L170.338 555.513ZM223.351 750L159.381 555.513L154.225 515.391H187.257L274.913 750H223.351ZM220.45 662.666V700.532H96.5391V662.666H220.45Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1ToA);
export default __webpack_public_path__ + "static/media/1_to_a.93a5c541172ae6352b7179c925fcff68.svg";
export { ForwardRef as ReactComponent };